import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import AppRow from "src/commun/composants/grille/AppRow";
import styles from "./AppTuile.scss";
import AppCol from "src/commun/composants/grille/AppCol";
import { Publicite } from "src/domain/User";
import parse from "html-react-parser";
import { useAppState } from "src/app/state/StateProvider";
import { goToUrl } from "src/app/menu/menuutil";
import { useNavigate } from "react-router-dom";
import AppAsyncImage from "src/commun/composants/AppAsyncImage/AppAsyncImage";

export type AppTuilePubProps = {
  pub: Publicite;
}

const AppTuilePub = ({ pub }: AppTuilePubProps) => {
  const { tString } = useAppText();
  const navigate = useNavigate();
  const [{ langue }] = useAppState();

  let label;
  let content;
  if (langue === "fr") {
    label = pub.labelFr;
    content = pub.contenuHtmlFr;
  } else if (langue === "de") {
    label = pub.labelDe;
    content = pub.contenuHtmlDe;
  } else {
    label = pub.labelEn;
    content = pub.contenuHtmlEn;
  }

  return (
    <AppRow
      className={`${styles.tuileContainer} ${styles.tuileContainerPub} ${pub.url && "cursor-pointer"}`}
      onClick={() => {
        if (pub.url) {
          goToUrl(pub.url, true, navigate);
        }
      }}
    >
      {!pub.serviceSouscrit && <span className={`${styles.flagNew}`}>{tString("service.pub.nouveau")}</span>}
      <AppCol>
        <AppRow>
          {pub.withIcone &&
            <AppCol xs={1} className={styles.iconContainer}>
              <AppAsyncImage
                serviceCode={pub.serviceCode}
                alt={label}/>
            </AppCol>
          }
          <AppCol className={styles.serviceName}>
            {label}
          </AppCol>
        </AppRow>
        <AppRow>
          <AppCol className={styles.descriptionText}>
            {parse(content)}

            {/*
            Exemple de contenu avec video :
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.<br/><br/> Ut enim ad minim veniamsequat.
<div class="media-container"> <iframe src="https://www.youtube.com/embed/msizPweg3kE?autoplay=1&mute=1" frameborder="0" allow="autoplay; encrypted-media; gyroscope;" allowfullscreen></iframe> </div>
<div class="arrowLine row"><span class="lblSabonner" title="Souscrire">Souscrire</span></div>

            Exemple de contenu avec image :
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.<br/><br/> Ut enim ad minim veniamsequat.
<div class="media-container"><img src="https://img.freepik.com/photos-gratuite/beaute-abstraite-automne-dans-motif-veines-feuilles-multicolores-genere-par-ia_188544-9871.jpg?size=626&ext=jpg&ga=GA1.1.2008272138.1720915200&semt=ais_user"/> </div>
<div class="arrowLine row"><span class="lblSabonner" title="Souscrire">Souscrire</span></div>
            */}

            {/* Si la pub est liée à un service alors on gère le btn pour afficher le bon label */}
            {pub.serviceCode && (
              <div className="arrowLine row"><span className="lblSabonner" title={tString(pub.serviceSouscrit ? "global.acceder" : "global.sabonner")}>{tString(pub.serviceSouscrit ? "global.acceder" : "global.sabonner")}</span></div>
            )}
          </AppCol>
        </AppRow>
      </AppCol>
    </AppRow>
  );
};


export default AppTuilePub;
